/**
 * AccessAuthorities — static role constants for permission checks.
 * Extracted from legacy/index.ts for direct ES module import.
 */

export class AccessAuthorities {
    public static ROLE_ACTIVITY_REPORT                  = "ROLE_ACTIVITY_REPORT";
    public static ROLE_USER_MANAGEMENT                  = "ROLE_USER_MANAGEMENT";
    public static ROLE_ACCESS_MANAGEMENT                = "ROLE_ACCESS_MANAGEMENT";
    public static ROLE_PERMISSIONS_AUDIT_LOG            = "ROLE_PERMISSIONS_AUDIT_LOG";
    public static ROLE_COMPANY_PROFILE                  = "ROLE_COMPANY_PROFILE";
    public static ROLE_CLIENT_MANAGEMENT                = "ROLE_CLIENT_MANAGEMENT";
    public static ROLE_PAYMENT_MANAGEMENT               = "ROLE_PAYMENT_MANAGEMENT";
    public static ROLE_ORNA_NOTES_READ                  = "ROLE_ORNA_NOTES_READ";
    public static ROLE_ORNA_NOTES_UPDATE                = "ROLE_ORNA_NOTES_UPDATE";
    public static ROLE_ORNA_NOTES_DELETE                = "ROLE_ORNA_NOTES_DELETE";
    public static ROLE_ORNA_NOTES_SAVE                  = "ROLE_ORNA_NOTES_SAVE";
    public static ROLE_ORNA_NOTES_ON_BEHALF_OF          = "ROLE_ORNA_NOTES_ON_BEHALF_OF";
    public static ROLE_ORNA_ADVISORY_READ               = "ROLE_ORNA_ADVISORY_READ";
    public static ROLE_ORNA_ADVISORY_SAVE               = "ROLE_ORNA_ADVISORY_SAVE";
    public static ROLE_ORNA_ADVISORY_UPDATE             = "ROLE_ORNA_ADVISORY_UPDATE";
    public static ROLE_ORNA_ADVISORY_DELETE             = "ROLE_ORNA_ADVISORY_DELETE";
    public static ROLE_ORNA_ADVISORY_AUDIT_LOG          = "ROLE_ORNA_ADVISORY_AUDIT_LOG";
    public static ROLE_REPORT_APPROVAL                  = "ROLE_REPORT_APPROVAL";
    public static ROLE_CAD                              = "ROLE_CAD";
    public static ROLE_FORCE_ADD_OFFICER_TO_CALL_CARD   = "ROLE_FORCE_ADD_OFFICER_TO_CALL_CARD";
    public static ROLE_MDT                              = "ROLE_MDT";
    public static ROLE_MDT_CALL_CARD_SAVE               = "ROLE_MDT_CALL_CARD_SAVE";
    public static ROLE_MDT_CALL_CARD_UPDATE_IF_PRIMARY  = "ROLE_MDT_CALL_CARD_UPDATE_IF_PRIMARY";
    public static ROLE_MDT_CALL_CARD_UPDATE_IF_BACKUP   = "ROLE_MDT_CALL_CARD_UPDATE_IF_BACKUP";
    public static ROLE_MDT_CALL_CARD_UPDATE             = "ROLE_MDT_CALL_CARD_UPDATE";
    public static ROLE_ACCESS_PENDING_CASE_REPORTS      = "ROLE_ACCESS_PENDING_CASE_REPORTS";
    public static ROLE_ADMIN                            = "ROLE_ADMIN";
    public static ROLE_MDT_UPDATE_RESPONSE_TIMES        = "ROLE_MDT_UPDATE_RESPONSE_TIMES";
    public static ROLE_TOUR                             = "ROLE_TOUR";
    public static ROLE_GUARD_TOUR                       = "ROLE_GUARD_TOUR";
    public static ROLE_VIEW_OWN_APPROVED_CASE_REPORTS   = "ROLE_VIEW_OWN_APPROVED_CASE_REPORTS";
    public static ROLE_VIEW_OTHER_USERS_APPROVED_CASE_REPORTS = "ROLE_VIEW_OTHER_USERS_APPROVED_CASE_REPORTS";
    public static ROLE_NPSD_DATA_SAVE                   = "ROLE_NPSD_DATA_SAVE";
    public static ROLE_NPSD_DATA_UPDATE                 = "ROLE_NPSD_DATA_UPDATE";
    public static ROLE_CALL_CARD_CLOSE                  = "ROLE_CALL_CARD_CLOSE";
    public static ROLE_CLIENT_PORTAL_MANAGEMENT         = "ROLE_CLIENT_PORTAL_MANAGEMENT";
    public static ROLE_VIEW_COMPANY_DOCUMENTS           = "ROLE_VIEW_COMPANY_DOCUMENTS";
    public static ROLE_UPDATE_COMPANY_DOCUMENTS         = "ROLE_UPDATE_COMPANY_DOCUMENTS";
    public static ROLE_ANALYTICS_REPORT_PDF             = "ROLE_ANALYTICS_REPORT_PDF";
    public static ROLE_CALL_CARD_MANAGEMENT             = "ROLE_CALL_CARD_MANAGEMENT";
    public static ROLE_ACTIVITY_REPORT_MANAGEMENT       = "ROLE_ACTIVITY_REPORT_MANAGEMENT";
    public static ROLE_CASE_REPORT_MANAGEMENT           = "ROLE_CASE_REPORT_MANAGEMENT";
    public static ROLE_NOC_MANAGEMENT                   = "ROLE_NOC_MANAGEMENT";
    public static ROLE_EMERGENCY_LOOKUP                 = "ROLE_EMERGENCY_LOOKUP"
    public static ROLE_USER_PROFILE_NOTES               = "ROLE_USER_PROFILE_NOTES"
    public static ROLE_VIEW_OTHER_USER_PROFILES         = "ROLE_VIEW_OTHER_USER_PROFILES"
    public static ROLE_EDIT_OTHER_USER_PROFILES         = "ROLE_EDIT_OTHER_USER_PROFILES"
    public static ROLE_VIEW_OWN_CLOSED_CALL_CARDS       = 'ROLE_VIEW_OWN_CLOSED_CALL_CARDS'
    public static ROLE_VIEW_OTHER_USERS_CLOSED_CALL_CARDS = 'ROLE_VIEW_OTHER_USERS_CLOSED_CALL_CARDS'
    public static ROLE_CALL_CARD_AUDIT_LOG              = 'ROLE_CALL_CARD_AUDIT_LOG'
    public static ROLE_CALL_COMMENT_UPDATE              = 'ROLE_CALL_COMMENT_UPDATE'
    public static ROLE_CALL_CARD_PDF                    = 'ROLE_CALL_CARD_PDF'
    public static ROLE_UPDATE_CLOSED_CALL_CARDS         = 'ROLE_UPDATE_CLOSED_CALL_CARDS'
    public static ROLE_UNAPPROVE_CASE_REPORTS           = 'ROLE_UNAPPROVE_CASE_REPORTS'
    public static ROLE_CALL_CARD_REOPEN                 = 'ROLE_CALL_CARD_REOPEN'
    public static ROLE_VIEW_USER_PROFILE                = 'ROLE_VIEW_USER_PROFILE'
    public static ROLE_VIEW_MESSAGING                   = 'ROLE_VIEW_MESSAGING'
    public static ROLE_UPDATE_MAP_OVERLAY               = 'ROLE_UPDATE_MAP_OVERLAY'
    public static ROLE_CASE_REPORT                      = 'ROLE_CASE_REPORT'
    public static ROLE_LOCATION_ALERT_MANAGEMENT        = 'ROLE_LOCATION_ALERT_MANAGEMENT'
    public static ROLE_LOCATION_ALERT_MANAGEMENT_VIEW   = 'ROLE_LOCATION_ALERT_MANAGEMENT_VIEW'
    public static ROLE_ORNA_ADVISORY_TYPE_MANAGE        = 'ROLE_ORNA_ADVISORY_TYPE_MANAGE'
    public static ROLE_CUSTOM_LOCATION_VIEW_SECTION     = 'ROLE_CUSTOM_LOCATION_VIEW_SECTION'
    public static ROLE_CUSTOM_LOCATION_SAVE             = 'ROLE_CUSTOM_LOCATION_SAVE'
    public static ROLE_CUSTOM_LOCATION_UPDATE           = 'ROLE_CUSTOM_LOCATION_UPDATE'
    public static ROLE_CUSTOM_LOCATION_DELETE           = 'ROLE_CUSTOM_LOCATION_DELETE'
    public static ROLE_CUSTOM_LOCATION_AUDIT_LOG        = 'ROLE_CUSTOM_LOCATION_AUDIT_LOG'
    public static ROLE_COMPANY_VEHICLE_MANAGEMENT       = 'ROLE_COMPANY_VEHICLE_MANAGEMENT'
    public static ROLE_ASSIGN_OFFICER_TO_COMPANY_VEHICLE = 'ROLE_ASSIGN_OFFICER_TO_COMPANY_VEHICLE'
    public static ROLE_UPDATE_COMPLETED_GUARD_TOUR_STOP = 'ROLE_UPDATE_COMPLETED_GUARD_TOUR_STOP'
    public static ROLE_MAP_OVERLAY_AREA_VISIBILITY      = 'ROLE_MAP_OVERLAY_AREA_VISIBILITY'
    public static ROLE_CALL_SIGN_MANAGEMENT             = 'ROLE_CALL_SIGN_MANAGEMENT'
    public static ROLE_STATUS_UPDATE_MANAGEMENT         = 'ROLE_STATUS_UPDATE_MANAGEMENT'
    public static ROLE_DISPATCH_OFFICER_STATUS          = 'ROLE_DISPATCH_OFFICER_STATUS'
    public static ROLE_DISPATCH_ANY_STATUS              = 'ROLE_DISPATCH_ANY_STATUS'
    public static ROLE_MILEAGE_DATA_EXPORT              = 'ROLE_MILEAGE_DATA_EXPORT'

    // Custom Form permissions
    public static ROLE_FORM_MANAGEMENT                  = 'ROLE_FORM_MANAGEMENT'
    public static ROLE_FORM_ENTRY                       = 'ROLE_FORM_ENTRY'

    // Citation permissions
    public static ROLE_CITATION_VIEW                    = 'ROLE_CITATION_VIEW'
    public static ROLE_CITATION_CREATE                  = 'ROLE_CITATION_CREATE'
    public static ROLE_CITATION_EDIT                    = 'ROLE_CITATION_EDIT'
    public static ROLE_CITATION_EDIT_ALL                = 'ROLE_CITATION_EDIT_ALL'
    public static ROLE_CITATION_DELETE                  = 'ROLE_CITATION_DELETE'
    public static ROLE_CITATION_VOID                    = 'ROLE_CITATION_VOID'
    public static ROLE_CITATION_INTERNAL_PDF            = 'ROLE_CITATION_INTERNAL_PDF'
    public static ROLE_CITATION_EXPORT                  = 'ROLE_CITATION_EXPORT'
    public static ROLE_CITATION_AUDIT_LOG               = 'ROLE_CITATION_AUDIT_LOG'
    public static ROLE_CITATION_MANAGEMENT              = 'ROLE_CITATION_MANAGEMENT'
}

// Keep window registration for backward compat with code still using (window as any).AccessAuthorities
(window as any).AccessAuthorities = AccessAuthorities;
